import z from 'zod';
import { createAnalyticsSchema } from './../factory/createAnalyticsSchema';
export var TestDataSchema = createAnalyticsSchema({
    ear: z.union([z.literal('left'), z.literal('right')]).optional(),
    name: z.string().optional(),
    steps: z.array(z.object({
        challenge: z.union([z.array(z.number()), z.literal('skipped')]),
        response: z
            .union([z.array(z.number()), z.literal('skipped')])
            .default('skipped'),
        snr: z.union([z.number(), z.literal('skipped')]).default('skipped'),
        passed: z.union([z.boolean(), z.literal('skipped')]).default('skipped'),
        timestamp: z.union([z.number(), z.literal('skipped')]).default('skipped'),
    })),
    completion: z.union([
        z.literal('not-started'),
        z.literal('in-progress'),
        z.literal('complete'),
        z.literal('discontinued'),
    ]),
    result: z.object({
        score: z.union([z.number(), z.literal('No result')]).default('No result'),
        category: z.string().default('No result'),
        pass: z.union([z.boolean(), z.literal('No result')]).default('No result'),
        averageSnr: z
            .union([z.number(), z.literal('No result')])
            .default('No result'),
        timestamp: z
            .union([z.number(), z.literal('No result')])
            .default('No result'),
    }),
});
